import ModalOrderItemDetail from './ModalOrderItemDetail'

const ModalFulfillmentResult = ({ isOpen, toggle, transaction }) => {
  return (
    <ModalOrderItemDetail
      isOpen={isOpen}
      toggle={toggle}
      transaction={transaction}
      type="sellerfills"
    />
  )
}

export default ModalFulfillmentResult
